// Shown by useBillableUnitsGuard right before a driver or vehicle
// activation/deactivation actually saves, whenever that change would move
// the tenant's billable base units (see src/lib/billableUnits.ts). Never
// blocks the action -- Confirm always lets it through, this is purely a
// heads-up so nobody's surprised by their bill changing.
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';

interface BillableUnitsWarningDialogProps {
  open: boolean;
  fromUnits: number;
  toUnits: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const BillableUnitsWarningDialog: React.FC<BillableUnitsWarningDialogProps> = ({
  open,
  fromUnits,
  toUnits,
  onConfirm,
  onCancel,
}) => {
  const increasing = toUnits > fromUnits;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldAlert className="h-4 w-4 text-yellow-500" />
            Billing will change
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          This will {increasing ? 'increase' : 'decrease'} your billable base units from{' '}
          <span className="font-semibold text-foreground">{fromUnits}</span> to{' '}
          <span className="font-semibold text-foreground">{toUnits}</span>.
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm} className="golden-button">
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BillableUnitsWarningDialog;
